const MonthlyAllocationModal = ({
  monthlyAllocationModalInfo,
  saving,
  onCancel,
  onSaveHoursOnly,
  onCompleteAndInvoice,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md">
        <h4 className="text-lg font-semibold mb-4 text-gray-800">Monthly Allocation Complete</h4>
        <div className="mb-4">
          <p className="text-gray-700 mb-2">
            Adding <strong>{monthlyAllocationModalInfo.proposedHours} hours</strong> will complete your monthly allocation
            of <strong>{monthlyAllocationModalInfo.monthlyAllocationTotal} hours</strong> for {monthlyAllocationModalInfo.monthYear}.
          </p>
          <p className="text-gray-700 mb-4">
            Total hours after this job: <strong>{monthlyAllocationModalInfo.totalAfterProposed} hours</strong>
          </p>
          <p className="text-gray-700 font-medium mb-2">
            Would you like to generate invoices for all completed jobs in {monthlyAllocationModalInfo.monthYear}?
          </p>
          {monthlyAllocationModalInfo.remainingJobsInMonth > 1 && (
            <p className="text-amber-600 text-sm">
              Note: {monthlyAllocationModalInfo.remainingJobsInMonth - 1} job(s) in this month remain incomplete and will not be auto-completed.
            </p>
          )}
        </div>
        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 hover:bg-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            disabled={saving}
          >
            Cancel
          </button>
          <button
            onClick={onSaveHoursOnly}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            disabled={saving}
          >
            Save Hours Only
          </button>
          <button
            onClick={onCompleteAndInvoice}
            className="px-4 py-2 text-sm font-medium text-white bg-green-600 hover:bg-green-700 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            disabled={saving}
          >
            Complete & Generate Invoice
          </button>
        </div>
      </div>
    </div>
  );
};

export default MonthlyAllocationModal;
